import React from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import product1 from "assets/img/examples/office1.png";
import product2 from "assets/img/examples/office2.jpg";
import product3 from "assets/img/examples/office3.png";
import product4 from "assets/img/examples/office4.png";
import product5 from "assets/img/examples/office5.jpg";

const useStyles = makeStyles(() => ({
  office: {
    padding: "70px 0",
    textAlign: "center",
  },
  textCenter: {
    textAlign: "center",
  },
  title: {
    marginTop: "30px",
    marginBottom: "15px",
    fontWeight: "600",
    fontSize: "2.25rem",
    color: "#3C4858",
  },
  description: {
    color: "#999",
    fontSize: "1.1rem",
    marginBottom: "40px",
  },
  mlAuto: {
    marginLeft: "auto !important",
  },
  mrAuto: {
    marginRight: "auto !important",
  },
  imgContainer: {
    height: "300px",
    width: "100%",
    overflow: "hidden",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "30px",
    boxShadow:
      "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
  },
  imgFixedHeight: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px",
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
      transform: "scale(1.03)",
    },
  },
}));

const galleryImages = [
  { src: product1, alt: "Ajanda Tasarımı 1" },
  { src: product2, alt: "Ajanda Tasarımı 2" },
  { src: product3, alt: "Ajanda Detay 1" },
  { src: product4, alt: "Kullanım Senaryosu 1" },
  { src: product5, alt: "Kullanım Senaryosu 2" },
];

export default function SectionGallery() {
  const classes = useStyles();

  return (
    <div className={classes.office}>
      <GridContainer className={classes.textCenter}>
        <GridItem md={8} sm={8} className={classNames(classes.mrAuto, classes.mlAuto)}>
          <h2 className={classes.title}>İlham Veren Anlar</h2>
          <h4 className={classes.description}>
            Ajandalarımız sadece bir planlayıcı değil; stilinizi, üretkenliğinizi ve yaşam tarzınızı yansıtan bir yol arkadaşıdır.
          </h4>
        </GridItem>
      </GridContainer>

      <GridContainer>
        {galleryImages.map((image, index) => (
          <GridItem key={index} md={index < 3 ? 4 : 6} sm={index < 3 ? 4 : 6}>
            <div className={classes.imgContainer}>
              <img
                className={classes.imgFixedHeight}
                src={image.src}
                alt={image.alt}
              />
            </div>
          </GridItem>
        ))}
      </GridContainer>
    </div>
  );
}
